import { render, staticRenderFns } from "./RegexListEditor.vue?vue&type=template&id=0bafb017&scoped=true&"
import script from "./RegexListEditor.vue?vue&type=script&lang=js&"
export * from "./RegexListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bafb017",
  null
  
)

export default component.exports